var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupPlantIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.41 170.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#152021;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;}.cls-6{fill:#9ac31c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 164.41,
    height: 164.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 82.2,
    cy: 82.2,
    r: 82.2,
    transform: "translate(-34.05 82.2) rotate(-45)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.2,164.41A82.21,82.21,0,1,0,0,82.2a82.21,82.21,0,0,0,82.2,82.21",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.4,82.76A54.39,54.39,0,0,0,83,28.36,53.17,53.17,0,0,0,39.72,50.49H31.07a1.74,1.74,0,0,0-1.78,1.78V168.63a1.74,1.74,0,0,0,1.78,1.78H52a1.74,1.74,0,0,0,1.78-1.78V128.44A53.13,53.13,0,0,0,83,137.16a54.4,54.4,0,0,0,54.39-54.4",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.78,47.75c-26.45-16-57.19-13.08-63-27.48-13.5,58,27.93,107.2,76.26,86.37C100.17,78.25,62.13,72.9,46.49,51c24.2,17.28,51,21.28,64.34,44.06,6.06-25.55-3-39-17-47.29",
    transform: "translate(0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupPlantIcon);
export default __webpack_public_path__ + "static/media/SupPlant_Icon.b70e30bb8352366cef4f88226da81015.svg";
export { ForwardRef as ReactComponent };